// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1RXz3","content":"Consent_content__3PSl7","footer":"Consent_footer__a5mH6"};